import React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@routific/hive/v5';
import { VisitDtoModelType } from '../../../../store/mst/models';
import AddressErrorMessage from './AddressErrorMessage';
import { GeocodingMessage } from './GeocodingMessage';

interface Props {
  visit: VisitDtoModelType;
  canEditVisits: boolean;
}

const AddressRow: React.FC<Props> = ({ visit, canEditVisits }) => {
  const addressIsInvalid = visit.isInvalid;
  const addressIsQuestionable = visit.isQuestionable;
  const invalidOrQuestionable = addressIsInvalid || addressIsQuestionable;
  const address = visit.displayLocation;
  const addressIsGeocoding = !!visit.isGeocoding;

  const handleClickLink = () => {
    if (!canEditVisits) {
      return;
    }
    visit.resolveAddress();
  };
  return (
    <>
      <Typography variant="body" data-cy="order-details-content-address">
        {address}
      </Typography>
      {invalidOrQuestionable ? <AddressErrorMessage visit={visit} handleClickLink={handleClickLink} canEditVisits={canEditVisits} /> : undefined}
      {addressIsGeocoding && <GeocodingMessage/>}
    </>
  );
};

export default observer(AddressRow);
